module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/True-Detective-S3.015e723.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/True-Detective-S3.jpg
// module id = BmVv
// module chunks = 0